var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 17.3333L16.0013 12L20.0013 18V16H25.3346V6.66667C25.3346 5.196 24.1386 4 22.668 4H5.33464C3.86397 4 2.66797 5.196 2.66797 6.66667V22.6667C2.66797 24.1373 3.86397 25.3333 5.33464 25.3333H16.0013V20H6.66797L10.668 14.6667L12.0013 17.3333Z",
    fill: "#20A8E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3346 18.666H22.668V22.666H18.668V25.3327H22.668V29.3327H25.3346V25.3327H29.3346V22.666H25.3346V18.666Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIcon);
export default __webpack_public_path__ + "static/media/Driver_icon.19358cb05709504db5e42ed9c31a71eb.svg";
export { ForwardRef as ReactComponent };